const betStatusToScore = {
  winner: "Win",
  loser: "Loss",
  pass: "Pass",
  pending: ""
};

export default function SurvivorBetScore(bet, race, raceNumber, ticket) {
  var eliminated = ticket.get("eliminated_by_race_number");
  if (eliminated === undefined || eliminated === null || raceNumber <= eliminated) {
    if (bet) {
      return betStatusToScore[bet.get("status")];
    } else if (race.get("status") === "open") {
      return "";
    } else {
      return "Loss";
    }
  } else {
    return "––";
  }
}
